import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { CustomBlock } from "libs/ngx-email-builder/src/lib/blocks/custom-block/custom.block";
@Component({
  selector: "tail-custom-block-block",
  templateUrl: "custom-block.component.html",
  styleUrls: ["custom-block.component.scss"],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomBlockComponent extends CustomBlock {
}
